import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import FocusTrap from 'focus-trap-react';

import {openCloseFilterPanelMobile} from '../actions/page';
import {FilterPanelBase} from './FilterPanel';

import './FilterPanelMobile.scss';


class FilterPanelMobile extends React.PureComponent {
    state = {
        isMounted: false,
    }

    componentDidMount() {
        const appRoot = document.getElementById('root');
        this.filterPanelMobileMount = document.createElement('div');
        appRoot.appendChild(this.filterPanelMobileMount);

        this.setState({isMounted: true});
    }


    render() {
        return this.state.isMounted ? ReactDOM.createPortal(
            <div className="feed-search-page">
                <FocusTrap>
                    <div className="filter-panel--mobile-container">
                        {/* Since this mask is meant for mouse users to click to quickly escape, */}
                        {/* and since we already have a keyboard-tabbable element for closing the modal, */}
                        {/* we don't need to follow these lint rules */}
                        {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                        {/* eslint-disable jsx-a11y/no-static-element-interactions */}
                        <div
                            className="filter-panel--mobile-container-mask"
                            onClick={() => this.props.openCloseFilterPanelMobile(false)}
                        />
                        {/* eslint-enable jsx-a11y/click-events-have-key-events */}
                        {/* eslint-enable jsx-a11y/no-static-element-interactions */}
                        <FilterPanelBase {...this.props} isMobile={true} />
                    </div>
                </FocusTrap>
            </div>,
            this.filterPanelMobileMount
        ) : null;
    }
}


const _mapDispatchToProps = {
    openCloseFilterPanelMobile,
};

export default connect(
    undefined,
    _mapDispatchToProps
)(FilterPanelMobile);
